// extracted by mini-css-extract-plugin
module.exports = {"weekdays":"AddLocationModal_weekdays__3cEe_","wrapper":"AddLocationModal_wrapper__1Gddm"};